/**
 *  Constants for storage keys used throughout the application.
 *  Use these constants instead of magic strings to ensure consistency and ease of refactoring.
 */
export const STORAGE_KEYS = {
  // SessionStorage
  ARP_TOKEN: 'ARP_Token',
  FIREBASE_TOKEN: 'ARP_FirebaseToken',
  FIREBASE_AUTH_TOKEN: 'ARP_FirebaseAuthToken',
  FIREBASE_AUTH_TOKEN_EXPIRY: 'ARP_FirebaseAuthTokenExpiry',

  /**
   * PrimeNG stateful-table key for the plantation list. Bump the suffix whenever something like
   * filter key changes: sessionStorage survives a deploy, so a tab opened
   * on the previous version would otherwise restore its saved filter values under
   * a key that now means something else.
   * Ref: https://v20.primeng.org/table#stateful
   */
  PLANTATION_TABLE_STATE: 'plantation-table-v2',

  // LocalStorage
  /**
   * Remembered dataset choice as `Record<userKey, datasetName>`, keyed by user
   * so one account's choice is never read under another's. localStorage rather
   * than sessionStorage, which survives logout and login in the same tab.
   *
   * Shared by both pickers: the Plantations and Legality tabs keep independent
   * current selections but write the same remembered value, so the last dataset
   * chosen anywhere is the one that reopens.
   */
  SELECTED_DATASET: 'pmd-selected-dataset'
} as const;
